import { parseISO, format as formatDate } from "date-fns";


export function formatDateTick(locale) {
  return (dateStr) => {
    const date = parseISO(dateStr);

    return formatDate(date, "MMM do", { locale });
  };
}

